<div class="main-wrapper">
    <div class="register-container">
        <div class="logo-container">
            <a routerLink="/">
                <img src="../../../assets/img/safetly_image.webp" alt="Safetly Logo" loading="lazy">
            </a>
        </div>
        <div class="register-content">
            <div class="social-login">
                <h3>{{'buttons.register' | translate}}</h3>
                <div class="social-login-buttons">
                    <button (click)="signUpWithGoogle()" aria-label="Sign Up with Google">
                        <img src="../../../assets/svg/google-icon.svg" alt="Google Icon" loading="lazy">
                        {{'auth.sign-up-with-google' | translate}}
                    </button>
                    <button (click)="signUpWithMicrosoft()" aria-label="Sign Up with Microsoft">
                        <img src="../../../assets/img/microsoft-icon.png" alt="Microsoft Icon" loading="lazy">
                        {{'auth.sign-up-with-microsoft' | translate}}
                    </button>
                </div>
            </div>

            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="register-form" id="register-form">
                <div class="form-group">
                    <label for="email">{{'common.email' | translate}}</label>
                    <input type="email" id="email" class="form-control" formControlName="email" autocomplete>
                    <div class="error-message" *ngIf="shouldShowError('email')">
                        {{ getErrorMessage('email') }}
                    </div>
                </div>

                <div class="form-group">
                    <label for="password">{{'common.password' | translate}}</label>
                    <div class="password-input-container">
                        <input [type]="getPasswordFieldType('password')" id="password" class="form-control"
                            formControlName="password" autocomplete>
                        <button type="button" class="toggle-password" (click)="togglePasswordVisibility('password')" aria-label="Toggle password visibility">
                            <img loading="lazy" [src]="showPasswords ? '../../../assets/svg/show-password-icon.svg' : '../../../assets/svg/hide-password-icon.svg'"
                                [alt]="showPasswords ? 'Hide password' : 'Show password'" >
                        </button>
                        <span class="help-text">
                            {{'auth.register.password-help' | translate}}
                        </span>
                        <div class="error-message" *ngIf="shouldShowError('password')">
                            {{ getErrorMessage('password') }}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="confirmPassword">{{'auth.re-type-password' | translate}}</label>
                    <div class="re-type-password-input-container">
                        <input [type]="getPasswordFieldType('confirmPassword')" id="confirmPassword"
                            class="form-control" formControlName="confirmPassword" autocomplete>
                        <button type="button" class="toggle-re-type-password"
                            (click)="togglePasswordVisibility('confirmPassword')" aria-label="Toggle password visibility">
                            <img loading="lazy" [src]="showReTypePasswords ? '../../../assets/svg/show-password-icon.svg' : '../../../assets/svg/hide-password-icon.svg'"
                                [alt]="showReTypePasswords ? 'Hide password' : 'Show password'">
                        </button>
                        <span class="help-text">
                            {{'auth.register.re-type-password-help' | translate}}
                        </span>
                        <div class="error-message" *ngIf="shouldShowError('confirmPassword')">
                            {{ getErrorMessage('confirmPassword') }}
                        </div>
                        <div class="error-message"
                            *ngIf="registerForm.errors?.['mismatch'] && (confirmPassword.touched || formSubmitted)">
                            {{'form.validation.passwords-not-match' | translate}}
                        </div>
                    </div>
                </div>

                <button 
                    type="submit" 
                    class="register-btn" 
                    [disabled]="registerForm.invalid"
                    [ngClass]="{'disabled': registerForm.invalid}"
                    form="register-form" 
                    aria-label="Register">
                    {{'buttons.register' | translate}}
                </button>

                <div class="signin-link">
                    {{'auth.register.already-registered' | translate}}
                    <a routerLink="/login">
                        {{'buttons.login' | translate}}
                    </a>
                </div>
            </form>
        </div>
    </div>
    <div class="register-img" [ngClass]="{'video-loaded': isVideoLoaded}">
        <div class="video-placeholder" *ngIf="!isVideoLoaded">
            <app-progress-spinner 
                [color]="'primary'" 
                [diameter]="50" 
                [strokeWidth]="5"
                [mode]="'indeterminate'">
            </app-progress-spinner>
        </div>
        <video #registerVideo loop playsinline preload="auto" 
            (loadeddata)="onVideoLoaded()"
            (error)="onVideoError($event)"
            [style.opacity]="isVideoLoaded ? 1 : 0" loading="lazy">
            <source src="../../../assets/gifs/video-webm.webm" type="video/webm">
            <source src="../../../assets/gifs/video.mp4" type="video/mp4">
          
            <img src="../../../assets/img/safetly logo.png" alt="Safetly Logo" class="fallback-image" loading="lazy">
        </video>
    </div>
</div>